/*
    Copyright © 2025 TRIPLES INNOVATION. All rights reserved.
    Proprietary and confidential. This source code is the exclusive property of
    TRIPLES INNOVATION and protected by copyright and trade secret law.
    Any unauthorized use, copying, modification, distribution, or disclosure
    is strictly prohibited without prior written permission from TRIPLES INNOVATION.
    Use is subject to a written license agreement with TRIPLES INNOVATION.
*/


import { Box, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import useToast, { ToastType } from "../../hooks/useToast";
import { toast } from "react-hot-toast";
import useEntriesService from "../../services/useEntriesService";

interface MarkIrrelevantSuccessProps {
    licensePlate: string;
    markedAsIrrelevant?: boolean;
}

const MarkIrrelevantSuccess = ({ licensePlate, markedAsIrrelevant = true }: MarkIrrelevantSuccessProps) => {
    const { t } = useTranslation("common");
    const { markCarAsIrrelevant } = useEntriesService();
    const { showToast } = useToast();

    const onUndo = () => {
        toast.dismiss();
        showToast({
            message: t("search.markAsIrrelevantSuccessUndoSuccess", { licensePlate }),
            type: ToastType.PROMISE,
            promise: markCarAsIrrelevant(licensePlate, false),
        })
    };

    return (
        <Box display="flex">
            {markedAsIrrelevant ? t("search.markAsIrrelevantSuccess.irrelevant", { licensePlate }) : t("search.markAsIrrelevantSuccess.relevant", { licensePlate })}

            {markedAsIrrelevant && (
                <Button
                    color="inherit"
                    onClick={onUndo}
                >
                    {t("search.markAsIrrelevantSuccessUndo")}
                </Button>
            )}
        </Box>
    );
}

export default MarkIrrelevantSuccess;
